module.exports = __webpack_public_path__ + "img/www.citysearch.com.0016ec6c.png";